import { ILoadingIndicatorStyle } from '../models/index.js';
export const loadingIndicatorStyle: ILoadingIndicatorStyle = {
	width: '100px',
	height: '100px',
};
